// eslint-disable-next-line no-restricted-imports
import { Modal } from 'antd'

/**
 * antdのModalのimportはeslintで禁止しているため、useModalが必要な場合にはこちらを使用する
 * */
export const useAntdModal = () => Modal.useModal()
